import videoInterviewIcon from "resources/images/video-assessment-icon.png";
import liveInterviewIcon from "resources/images/live-interview-icon.png";
import VIHeaderImg from "resources/images/Criteria-VIMerch-Modal.png";
import LIHeaderImg from "resources/images/Criteria-LIMerch-Modal.png";

export const MERCH_MODAL_LIBRARY = {
  videoInterview: {
    labelName: "VIDEO INTERVIEW",
    iconImg: videoInterviewIcon,
    headerImg: VIHeaderImg,
    featureOverview: {
      1: {
        title: "Get more predictive insights",
        text: "Predict on-the-job performance with insights that offer twice the predictive validity.",
      },
      2: {
        title: "Create immersive, scenario-based assessments",
        text: "Immerse your candidates in real work scenarios and evaluate who can perform the role.",
      },
      3: {
        title: "Meet candidates at scale",
        text: "Fill your interview pipeline quickly and complete screening 75% faster.",
      },
      4: {
        title: "Reduce bias",
        text: "Use world-first diversity, equity, and inclusion tools to run a true blind recruitment process.",
      },
    },
  },
  liveInterview: {
    labelName: "LIVE INTERVIEW",
    iconImg: liveInterviewIcon,
    headerImg: LIHeaderImg,
    featureOverview: {
      1: {
        title: "Get a stronger talent signal",
        text: "Predict on-the-job performance with insights that offer twice the predictive validity over unstructured interviews.",
      },
      2: {
        title: "Build a structured interview in minutes",
        text: "Select from a library of interview questions that target job-related competencies that are critical to the success of your roles. Or add your own questions specific to your unique job requirements.",
      },
      3: {
        title: "Get hiring managers up to speed",
        text: "Take the burden off your hiring managers and interviewers by giving them ready-made tools to follow. They can quickly see what questions they should ask, along with evaluation guides for how to evaluate each response.",
      },
      4: {
        title: "All candidate insights in one place",
        text: "After each interviewer has rated a candidate, the platform combines the results into a final score report. No need to spend time collating messy results from different team members.",
      },
    },
  },
};
